export default __webpack_public_path__ + "static/media/ic_type_lesson.5d07260f.svg";